function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M21.055 12.459l-10.265-.06V7.386a5.133 5.133 0 1 1 10.266 0v5.074zm-10.007-.317l9.749.057V7.386a4.874 4.874 0 1 0-9.748 0v4.756z" /><path d="M20.319 12.382l-8.795-.052V7.244a4.402 4.402 0 0 1 4.398-4.397c2.126 0 4.398 1.562 4.398 5.946v3.59zm-8.536-.309l8.279.049V8.793c0-3.508-1.586-5.688-4.139-5.688a4.143 4.143 0 0 0-4.139 4.139v4.829z" /><path d="M23.326 29.747H8.675V12.214h14.651v17.533zm-14.393-.258h14.135V12.472H8.933v17.017z" /></svg>;
});